import {WhitelabelConfig} from "./WhitelabelConfig";
import {CompanyEnumIndices} from "@bdswiss/common-enums";

export const valutaMarkets: WhitelabelConfig = {
    whitelabel: CompanyEnumIndices.bdSwissMauritius,
    domainNames: [
        'valutamarkets.com',
        'valutamarkets.skyground-staging.com',
        'valutamarkets.local'
    ]
}
